export const RELATIONSHIP = [
  {
    type: '지인',
    background: '--beige100',
    color: '--beige500',
  },
  {
    type: '동료',
    background: '--purple100',
    color: '--purple500',
  },
  {
    type: '가족',
    background: '--green100',
    color: '--green500',
  },
  {
    type: '친구',
    background: '--blue100',
    color: '--blue500',
  },
];

export const FONT = [
  'Noto Sans',
  'Pretendard',
  '나눔명조',
  '나눔손글씨 손편지체',
];
